import axios from '@axios'

export default {
  namespaced: true,
  state:()=> ({
    root:null,
    loadings:0,
    list:[],
    rowsFrom:0,
    rowsTo:0,
    rowsTotal:0,
    perPage:10,
    currentPage:1,
    searchQuery:null,
    ownersFilter:null,
    ownersOptions:[],
    contractsFilter:null,
    contractsOptions:[]
  }),
  mutations:{
    updateRoot(state, payload){
      state.root = payload
    },
    startLoadingState(state){
      state.loadings += 1
    },
    stopLoadingState(state){
      state.loadings -= 1
    },
    updateList(state, payload){
      state.list = payload
    },
    updateRowsFrom(state, payload){
      state.rowsFrom = payload
    },
    updateRowsTo(state, payload){
      state.rowsTo = payload
    },
    updateRowsTotal(state, payload){
      state.rowsTotal = payload
    },
    updatePerPage(state, payload){
      state.perPage = payload.value
    },
    updateCurrentPage(state, payload){
      state.currentPage = payload.value
    },
    updateSearchQuery(state, payload){
      state.searchQuery = payload.value
    },
    updateOwnersFilter(state, payload){
      state.ownersFilter = payload.value
    },
    updateOwnersOptions(state, payload){
      state.ownersOptions = payload
    },
    updateContractsFilter(state, payload){
      state.contractsFilter = payload.value
    },
    updateContractsOptions(state, payload){
      state.contractsOptions = payload
    }
  },
  actions: {
    fetchFiltersOptions({ commit }){
      commit('startLoadingState')
      axios.get('filters/getFilterBy', { params:{
        type: 'plan',
        planType:'containerArea'
      }})
      .then(r => {
          commit('updateOwnersOptions', r.data.data.owners)
          commit('updateContractsOptions', r.data.data.contracts)
          commit('stopLoadingState')
      })
      .catch(error => console.log(error))
    },
    fetchList({ commit, getters }){
      commit('startLoadingState')
      axios.get('plans', { params:{
        length: getters.perPage,
        page: getters.currentPage,
        type:'containerArea',
        ...(getters.isUsingSearchQueryFilter && {q: getters.searchQuery}),
        ...(getters.isUsingOwnersFilter && {owners: getters.ownersFilter}),
        ...(getters.isUsingContractsFilter && {contracts: getters.contractsFilter}),

      }})
      .then(r => {
          commit('updateList', r.data.plans.data)
          commit('updateRowsFrom', r.data.plans.meta.from)
          commit('updateRowsTo', r.data.plans.meta.to)
          commit('updateRowsTotal', r.data.plans.meta.total)
          commit('stopLoadingState')
      })
      .catch(error => console.log(error))
    },
    export({ commit, getters }, payload ){
      commit('startLoadingState')
      axios.post('export', {
            export: 'plansList',
            type:'containerArea',
            exporter: payload.type,
        ...(getters.isUsingSearchQueryFilter && {q: getters.searchQuery}),
        ...(getters.isUsingOwnersFilter && {owners: getters.ownersFilter}),
        ...(getters.isUsingContractsFilter && {contracts: getters.contractsFilter}),
      }, { responseType: 'blob' })
      .then(response => {
          const type = response.headers['content-type']
          const blob = new Blob([response.data], { type, encoding: 'UTF-8' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = `container-Area-Plans.${payload.type}`
          link.click()

          commit('stopLoadingState')

      })
      .catch(error => console.log(error))
    },
    exportPDF({ dispatch }){
      dispatch('export' , { type:'pdf' })
    },
    exportXLSX({ dispatch }){
      dispatch('export' , { type:'xlsx' })
    },
    delete({ commit, getters, dispatch }, payload){
      getters.root.$swal({
        icon:'warning',
        title: getters.root.$i18n.t("SWAL_CONFIRM_BOX_TITLE"),
        text: getters.root.$i18n.t('PLANS_DELETE_CONFIRMATION'),
        showCancelButton: true,
        confirmButtonText: getters.root.$i18n.t('SWAL_YES_BUTTON_LABEL'),
        cancelButtonText: getters.root.$i18n.t('SWAL_CANCEL_BUTTON_LABEL'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( confirmBox => {
        if ( confirmBox.isConfirmed) {
          commit('startLoadingState')
          axios.delete(`plans/${payload.id}`, {params:{type:'containerArea'}})
          .then( response => {
              
              getters.root.$bvToast.toast(
                getters.root.$i18n.t('PLANS_DELETE_SUCCESS_MESSAGE'), {
                variant: 'success',
                solid: true,
              })
              dispatch('fetchList')
              dispatch('fetchFiltersOptions')
            }).catch( reason => {
              getters.root.$bvToast.toast(
                getters.root.$i18n.t('PLANS_DELETE_FAILURE_MESSAGE'), {
                variant: 'danger',
                solid: true,
              })
            }).finally(()=> commit('stopLoadingState'))
        }
      })
    }
  },
  getters:{
    root(state){
      return state.root
    },
    isLoading(state){
      return state.loadings > 0
    },
    perPageOptions(){
      return [2,10,50,100,500]
    },
    perPage(state){
      return state.perPage
    },
    currentPage(state){
      return state.currentPage
    },
    searchQuery(state){
      return state.searchQuery
    },
    isUsingSearchQueryFilter(state){
      return state.searchQuery !== null
    },
    ownersFilter(state){
      return state.ownersFilter
    },
    ownersOptions(state){
      return state.ownersOptions
    },
    isUsingOwnersFilter(state){
      return state.ownersFilter !== null
    },
    contractsFilter(state){
      return state.contractsFilter
    },
    contractsOptions(state){
      return state.contractsOptions
    },
    isUsingContractsFilter(state){
      return state.contractsFilter !== null
    },
    list(state){
      return state.list
    },
    tableMeta(state, getters){
      return `${ getters.root.$i18n.t('Showing') } ${ state.rowsFrom } to ${ state.rowsTo } of ${ state.rowsTotal } ${ getters.root.$i18n.t('entries') }`
    },
    tableTotalRows(state){
      return state.rowsTotal
    },
    tableColumns(state, getters){
      return [
        { 
          key: 'owner',
          label: getters.root.$i18n.t('owner'),
          sortable: true,
        },
        { 
          key: 'contract',
          label: getters.root.$i18n.t('contract'),
          sortable: true
        },
        { 
          key: 'device',
          label: getters.root.$i18n.t('device'),
          sortable: true,
          formatter: value =>  getters.root.$i18n.t(value)
        },
        { 
          key: 'name',
          label: getters.root.$i18n.t('name'),
          sortable: true
        },
        { 
          key: 'data.areas',
          label: getters.root.$i18n.t('CONTAINER_AREA_PLAN_CONTAINERS_COUNT'),
          formatter: value =>  value.length,
          sortable: true
        },
        { 
          key: 'actions',
          label: getters.root.$i18n.t('actions')
        }
      ]
    }
  }
}
